// import { useEffect } from "react";
// import logo from "./logo.svg";
import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./Pages/About";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import CookiePolicy from "./Pages/CookiePolicy";
import TermsOfUse from "./Pages/TermsOfUse";
import UserDashboard from "./component/DashboardUser/UserDashboard";
import Games from "./Pages/Responsive Games/Games";
import Playgame from "./Pages/Playgame/Playgame";
import NoteState from "./component/Context/NoteState";
import AuthProvider from "./component/Context/UserState";
import { CodeProvider } from "./component/Context/CodeContext";
import { GameDataProvider } from "./component/Context/GameDataContext";
// import { AuthContextProvider } from "./AuthContext";
import WalletState from "./component/Context/WalletState";
import PaymentState from "./component/Context/PaymentState";
import Sidebar from "./component/Sidebar/Sidebar";
import Layout from "./component/Layout/";
import Match from "../src/Pages/Playgame/PlayerMatch";
import Score from "./Pages/Playgame/Score";
import ScoreScreen from "./component/Score/Score";
import Onevsone from "./component/1vs1journey/Onevsone";
import Addbuddy from "./component/1vs1journey/Addbuddy";
import Notice from "./component/1vs1journey/Notice";
import { GamesMbl } from "./Pages/Responsive Games/gamesMobile/GamesMbl";
import WinPopup from "./component/winPopup/WinPopup";
import PlayGameMobile from "./Pages/Responsive Games/playMobile/PlayGameMobile";
import { useAuthContext } from "./AuthContext";
import LoosePopup from "./component/winPopup/LoosePopup";
import Home from "./Pages/Home";
import IntegrationService from "./Pages/IntegrationService";
import NftJourney from "./Pages/NftJourney";
import NftPopup from "./Pages/NftPopup";
import Nftpurchasepop from "./Pages/Nftpurchasepop";
import Salenftpop from "./Pages/Salenftpop";
import Developer from "./Pages/DeveloperPage/Developer";
import NetworkDetail from "./Pages/DeveloperPage/NetworkDetail";
import Roadmap from "./Pages/Roadmap/Roadmap";
import Blog from "./Pages/Blog/Blog";
import News from "./Pages/News/News";
// import BlogDetail from "./Pages/BlogDetail/BlogDetail";
import ContactSupport from "./Pages/ContactSupport/ContactSupport";
import Contactus from "./Pages/ContactSupport/Contactus";

import NotFound from "./Pages/NotFound/NotFound";
import Quitpopup from "./Pages/Playgame/QuitPopup/Quitpopup";
// import MediaAsset from "./Pages/MediaAsset/MediaAsset";
import MediaAsset from "./Pages/MediaAsset/MediaAsset";

const App = () => {
  const { isMobile } = useAuthContext();
  useEffect(() => {
    window.addEventListener('message', (message) => {
      if (message.data == 'IS_MOBILE_APP') {
        localStorage.setItem('IS_MOBILE_APP', 'true');
      }
    });
    // return () => window.removeEventListener('message', () => {});
  }, []);

  // console.log("is Mobile", isMobile);
  return (
    <AuthProvider>
      <NoteState>
        <WalletState>
          <PaymentState>
            <CodeProvider>
              <GameDataProvider>
                <BrowserRouter>
                  <Layout>
                    <Routes>
                      <Route exact path="/:id" element={<Home />} />
                      <Route exact path="/" element={<Home />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/home" element={<Home />} />
                      <Route
                        path="/privacy-policy"
                        element={<PrivacyPolicy />}
                      />
                      <Route path="/cookie-policy" element={<CookiePolicy />} />
                      <Route path="/terms-of-use" element={<TermsOfUse />} />
                      <Route path="/dashboard" element={<UserDashboard />} />
                      <Route
                        path="/Games"
                        element={isMobile ? <GamesMbl /> : <Games />}
                        name="abc"
                      />
                      <Route
                        path="/Playgame/:id"
                        element={
                          isMobile ? (
                            <PlayGameMobile mobile={true} />
                          ) : (
                            <Playgame />
                          )
                        }
                      />
                      <Route path="/sidebar" element={<Sidebar />} />
                      <Route path="/match" element={<Match />} />
                      <Route path="/win" element={<WinPopup />} />
                      <Route path="/loose" element={<LoosePopup />} />
                      <Route path="/score" element={<ScoreScreen />} />
                      <Route path="/onevsone" element={<Onevsone />} />
                      <Route path="/addbuddy" element={<Addbuddy />} />
                      <Route path="/notice" element={<Notice />} />
                      <Route
                        path="/playGameMobile"
                        element={<PlayGameMobile />}
                      />
                      <Route
                        path="/IntegrationService"
                        element={<IntegrationService />}
                      />
                      <Route path="/NftJourney" element={<NftJourney />} />
                      <Route path="/NftPopup" element={<NftPopup />} />
                      <Route
                        path="/Nftpurchasepop"
                        element={<Nftpurchasepop />}
                      />
                      <Route path="/Salenftpop" element={<Salenftpop />} />
                      <Route path="/Developer" element={<Developer />} />
                      <Route
                        path="/NetworkDetail"
                        element={<NetworkDetail />}
                      />
                      <Route path="/Roadmap" element={<Roadmap />} />
                      <Route path="/Blog" element={<Blog />} />
                      <Route path="/News" element={<News />} />
                      {/* <Route path="/Blog-Detail" element={<BlogDetail />} /> */}
                      <Route
                        path="/Contact-Support"
                        element={<ContactSupport />}
                      />

                      <Route path="/Contact-us" element={<Contactus />} />

                      <Route path="/404" element={<NotFound />} />
                      <Route path="/quit" element={<Quitpopup />} />
                      <Route path="/mediaAsset" element={<MediaAsset />} />
                    </Routes>
                  </Layout>
                </BrowserRouter>
              </GameDataProvider>
            </CodeProvider>
          </PaymentState>
        </WalletState>
      </NoteState>
    </AuthProvider>
  );
};

export default App;
